import { createFileRoute } from '@tanstack/react-router';

import { InvoiceInboxEmailPage } from '~/modules/invoice/inbox/InvoiceInboxEmailPage';
import { LoadingPage } from '~/modules/router/components';

import { i18n } from '~/utils';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from '../../incoming/-routeParams';

const title = i18n.t(($) => $.inbox.emailDetail.pageTitle, { ns: 'invoice' });

export const Route = createFileRoute('/(main)/invoices/inbox/$emailId/')({
  beforeLoad: createProtectedRoute({
    routePath: '/invoices/inbox/$emailId/',
    ...routeParams,
  }),
  component: InvoiceInboxEmailPage,
  head: () => getRouteHead(title),
  pendingComponent: LoadingPage,
  staticData: {
    AppBar: {
      title,
    },
  },
  wrapInSuspense: true,
});
